import { throttle } from "throttle-debounce";

const BEFORE_AFTER_TIMEOUT = 1000;
const BEFORE_AFTER_FADE_SPEED = 1000;
const SLICK_ARGS = {
	arrows: false,
	dots: true,
	slide: ".hero-slide",
	autoplay: true,
	autoplaySpeed: 3000,
	infinite: true,
	pauseOnHover: false,
};
const INTERSECTION_OPTS = {
	rootMargin: "-20%",
};

class HeroSection {
	constructor(el) {
		this.hasBecomeVisible = false;
		this.imageObserver = null;
		this.throttledIntersectionDelegate = null;
		this.beforeAfterTimeouts = [];
		/*globals jQuery:false */
		this.$el = jQuery(el);
		this.isSlideshow = false;
		this.slideshowObject = null;
		this.scrollCta = this.$el.find(".hero-container__scroll-cta");

		this.heroBefore;
		this.heroBeforeVisible;
		this.heroTransTimeout;
		this.heroTransSpeed;

		if (!this.$el.length) return;

		if (this.$el.hasClass("hero-container-section--is-slider")) {
			this.isSlideshow = true;

			this.initSlideshow();
		}

		this.initVisibilityCheck();

		if (this.scrollCta.length) {
			this.scrollCta.on("click", this.scrollCtaClick.bind(this));
		}
	}

	/**
	 * Initialize hero section as slick carousel slideshow
	 */
	initSlideshow() {
		this.$el
			.on("init", this.onSlideshowInit.bind(this))
			.on("beforeChange", this.onSlideshowBeforeChange.bind(this))
			.on("afterChange", this.onSlideshowAfterChange.bind(this))
			.slick(SLICK_ARGS);
	}

	/**
	 * Slick carousel init event handler
	 *
	 * @param Object evt
	 * @param Object slick carousel object
	 */
	onSlideshowInit(evt, slick) {
		//console.log('Hero::onSlideshowInit', slick);

		this.slideshowObject = slick;

		if (!this.hasBecomeVisible) return;

		// check current slide for video element
		this.checkCurrentSlideVideo(slick);

		// check current slide is before / after
		this.checkCurrentSlideBeforeAfter(slick);
	}

	/**
	 * Slick carousel beforeChange event handler
	 *
	 * @param Object evt
	 * @param Object slick carousel object
	 * @param Number currentSlide index
	 * @param Number nextSlide index
	 */
	onSlideshowBeforeChange(evt, slick, currentSlide, nextSlide) {
		if (!this.hasBecomeVisible) return;

		// check current and next slides for video element
		const $currentVid = jQuery(slick.$slides[currentSlide]).find("video");
		const $nextVid = jQuery(slick.$slides[nextSlide]).find("video");

		if ($currentVid.length) $currentVid[0].pause();
		if ($nextVid.length) {
			//$nextVid[0].currentTime = 0;
			$nextVid[0].play();
		}
	}

	/**
	 * Slick carousel afterChange event handler
	 *
	 * @param Object evt
	 * @param Object slick carousel object
	 */
	onSlideshowAfterChange(evt, slick) {
		// console.log("Hero::onSlideshowAfterChange slide: " + slick.currentSlide);
		// console.log("before / after timeouts", this.beforeAfterTimeouts);

		if (!this.hasBecomeVisible) return;

		// clear all timeouts
		let i;

		for (i = this.beforeAfterTimeouts.length; i > 0; i--) {
			clearTimeout(this.beforeAfterTimeouts.pop());
		}

		// undo started and completed transitions
		// reset all videos not on current slide
		for (i = 0; i < slick.$slides.length; i++) {
			if (i == slick.currentSlide) continue;

			jQuery(slick.$slides[i]).find(".hero-slide__background--before").stop(true, true).show();

			jQuery(slick.$slides[i])
				.find("video")
				.each(function () {
					this.currentTime = 0;
				});
		}

		// check current slide is before / after
		this.checkCurrentSlideBeforeAfter(slick);
	}

	/**
	 * Add event handlers to determine element visibility
	 * use either IntersectionObserver API if available
	 * fallback to use scroll, resize, and orientationChange
	 */
	initVisibilityCheck() {
		//console.log('Hero::initVisibilityCheck');

		if ("IntersectionObserver" in window) {
			this.imageObserver = new IntersectionObserver(this.intersectionCallback.bind(this), INTERSECTION_OPTS);

			this.imageObserver.observe(this.$el[0]);
		} else {
			this.throttledIntersectionDelegate = throttle(100, this.insersectionFallback.bind(this));

			document.addEventListener("scroll", this.throttledIntersectionDelegate);
			window.addEventListener("resize", this.throttledIntersectionDelegate);
			window.addEventListener("orientationChange", this.throttledIntersectionDelegate);

			this.insersectionFallback();
		}
	}

	/**
	 * IntersectionObserver API intersection handler
	 */
	intersectionCallback(entries) {
		// console.log("Hero::intersectionCallback", entries);

		if (entries[0].isIntersecting) {
			this.imageObserver.unobserve(this.$el[0]);

			this.onBecomeVisible();

			return;
		}
	}

	/**
	 * Fallback visibility events handler
	 */
	insersectionFallback() {
		//console.log('Hero::insersectionFallback');

		const scrollTop = window.pageYOffset;

		if (this.$el[0].offsetTop < window.innerHeight + scrollTop) {
			document.removeEventListener("scroll", this.throttledIntersectionDelegate);
			window.removeEventListener("resize", this.throttledIntersectionDelegate);
			window.removeEventListener("orientationChange", this.throttledIntersectionDelegate);

			this.onBecomeVisible();
		}
	}

	/**
	 * Init slideshow and non slideshow before after event handlers, timeout, video
	 */
	onBecomeVisible() {
		// console.log("Hero::onBecomeVisible");

		if (this.hasBecomeVisible) return;

		// do slide checks now that slideshow is in view
		if (this.isSlideshow) {
			if (this.slideshowObject) {
				// check current slide for video element
				this.checkCurrentSlideVideo(this.slideshowObject);

				// check current slide is before / after
				this.checkCurrentSlideBeforeAfter(this.slideshowObject);
			}

			// initialize non slideshow before / after slides
		} else {
			this.checkHeroVideo();
			this.checkHeroBeforeAfter();
		}

		// set inited flag
		this.hasBecomeVisible = true;
	}

	/**
	 * Check static hero has video element and play it
	 */
	checkHeroVideo() {
		const $vid = this.$el.find("video");

		if ($vid.length) {
			// console.log("found video in static hero", $vid[0]);

			$vid[0].play();
		}
	}

	/**
	 * Check current slide has video element and play it
	 *
	 * @param Object slick carousel object
	 */
	checkCurrentSlideVideo(slick) {
		// console.log("Hero::checkCurrentSlideVideo");

		const $currentVid = jQuery(slick.$slides[slick.currentSlide]).find("video");

		if ($currentVid.length) {
			// console.log("found video", $currentVid[0]);

			$currentVid[0].play();
		}
	}

	/**
	 * Check static hero is before / after and activate
	 */
	checkHeroBeforeAfter() {
		let transTimeout;
		let transSpeed;

		const heroSlide = this.$el.find(".hero-slide").first();

		if (!heroSlide.length || !heroSlide.hasClass("hero-slide--is-before-after")) return;

		const $before = heroSlide.find(".hero-slide__background--before");

		if (!$before.length) return;

		transTimeout = heroSlide.data("before-after-timeout");
		if (!transTimeout || isNaN(transTimeout)) {
			transTimeout = BEFORE_AFTER_TIMEOUT;
		}

		transSpeed = heroSlide.data("before-after-speed");
		if (!transSpeed || isNaN(transSpeed)) {
			transSpeed = BEFORE_AFTER_FADE_SPEED;
		}

		this.heroBefore = $before;
		this.heroBeforeVisible = true;
		this.heroTransTimeout = transTimeout;
		this.heroTransSpeed = transSpeed;

		this.animateHeroBeforeAfter();
	}

	animateHeroBeforeAfter() {
		setTimeout(() => {
			//console.log('before after timeout fire!');

			if (this.heroBeforeVisible) {
				this.heroBefore.fadeOut(this.heroTransSpeed, () => {
					this.heroBeforeVisible = false;
					this.animateHeroBeforeAfter();
				});
			} else {
				this.heroBefore.fadeIn(this.heroTransSpeed, () => {
					this.heroBeforeVisible = true;
					this.animateHeroBeforeAfter();
				});
			}
		}, this.heroTransTimeout);
	}

	/**
	 * Check current slide is before / after type and activate transition
	 *
	 * @param Object slick carousel object
	 */
	checkCurrentSlideBeforeAfter(slick) {
		let home;
		//let pauseSlider;
		let beforeVisible;
		let transTimeout;
		let transSpeed;

		const $slide = jQuery(slick.$slides[slick.currentSlide]);

		if ($slide.hasClass("hero-slide--is-before-after")) {
			if ($slide.data("before-visible") === undefined) {
				$slide.data("before-visible", true);
			}

			//pauseSlider = slick.options.autoplay;

			transTimeout = $slide.data("before-after-timeout");
			if (!transTimeout || isNaN(transTimeout)) {
				transTimeout = BEFORE_AFTER_TIMEOUT;
			}

			transSpeed = $slide.data("before-after-speed");
			if (!transSpeed || isNaN(transSpeed)) {
				transSpeed = BEFORE_AFTER_FADE_SPEED;
			}

			//if ( pauseSlider ) {
			//	slick.pause();
			//}

			this.animateSlideBeforeAfter(slick, $slide, transTimeout, transSpeed);
		}
	}

	animateSlideBeforeAfter(slick, $slide, transTimeout, transSpeed) {
		this.beforeAfterTimeouts.push(
			setTimeout(() => {
				// console.log("before after slide timeout fire!", this.beforeAfterTimeouts.length);

				if ($slide.data("before-visible")) {
					$slide.find(".hero-slide__background--before").fadeOut(transSpeed, () => {
						$slide.data("before-visible", false);

						//if ( pauseSlider ) {
						//	slick.play();
						//}

						this.animateSlideBeforeAfter(slick, $slide, transTimeout, transSpeed);
					});
				} else {
					$slide.find(".hero-slide__background--before").fadeIn(transSpeed, () => {
						$slide.data("before-visible", true);

						//if ( pauseSlider ) {
						//	slick.play();
						//}

						this.animateSlideBeforeAfter(slick, $slide, transTimeout, transSpeed);
					});
				}
			}, transTimeout),
		);
	}

	/**
	 * Scroll to Explore Link Click Handler
	 */
	scrollCtaClick(evt) {
		evt.preventDefault();

		jQuery("html, body").animate(
			{
				scrollTop: this.$el.closest(".def6-block").next().offset().top,
			},
			200,
		);

		return false;
	}
}

jQuery(document).ready(function () {
	let i;

	let heroSections = document.querySelectorAll(".hero-container-section");

	for (i = 0; i < heroSections.length; i++) {
		new HeroSection(heroSections[i]);
	}
});
